export default "__VITE_ASSET__685d8200__"